import React from 'react';
const STROKE = '#5e2a56';
// Same opacity as the construction lines at the top of the hero.
const LINE_OPACITY = 0.06;

// Broad, scattered construction geometry — lines only, mirrored in spirit to the hero top
// but composed differently: rising arcs from the bottom, crossing diagonals, offset grid.
const horizontals = [{
  y: 140,
  dash: '24 6 3 6'
}, {
  y: 360,
  dash: '2 6'
}, {
  y: 640,
  dash: '24 6 3 6'
}, {
  y: 880,
  dash: '2 6'
}];
const verticals = [{
  x: 72,
  dash: '24 6 3 6'
}, {
  x: 236,
  dash: '2 6'
}, {
  x: 1124,
  dash: '2 6'
}, {
  x: 1288,
  dash: '24 6 3 6'
}];
const sweeps = ['M-40 260 A760 760 0 0 0 1400 260', 'M140 120 A560 560 0 0 0 1220 120', 'M-80 1000 A460 460 0 0 1 340 320', 'M1440 1000 A460 460 0 0 0 1020 320'];
const rays = ['M0 1000 L560 300', 'M1360 1000 L800 300', 'M0 520 L680 700 L1360 520'];
function ticks(y: number, from: number, to: number, step: number) {
  const out: string[] = [];
  for (let x = from; x <= to; x += step) out.push(`M${x} ${y - 3}V${y + 3}`);
  return out.join('');
}
export function ContactBlueprint() {
  return <svg className="pointer-events-none absolute inset-0 hidden h-full w-full lg:block" viewBox="0 0 1360 1000" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-105" data-mp="3tin6uvcj9lbv">
      <g fill="none" stroke={STROKE} strokeOpacity={LINE_OPACITY} strokeWidth="1" data-id="element-106" data-mp="7aduq0rmre3x">
        {horizontals.map(({
        y,
        dash
      }) => <line key={`h${y}`} x1="0" y1={y} x2="1360" y2={y} strokeDasharray={dash} data-id="element-107" data-mp="l0hac8w089ke" />)}
        {verticals.map(({
        x,
        dash
      }) => <line key={`v${x}`} x1={x} y1="0" x2={x} y2="1000" strokeDasharray={dash} data-id="element-108" data-mp="uzybqe4841ak" />)}
        {sweeps.map(d => <path key={d} d={d} data-id="element-109" data-mp="q0vehfuhizd5" />)}
        {rays.map(d => <path key={d} d={d} strokeDasharray="1 5" data-id="element-110" data-mp="2wrbf2yqjm14i" />)}
        <path d={ticks(140, 16, 1344, 32)} data-id="element-111" data-mp="2wrux0fg70pij" />
        <path d={ticks(880, 16, 1344, 32)} data-id="element-112" data-mp="2rt1jin0woyid" />
      </g>
    </svg>;
}